export default __webpack_public_path__ + "static/media/floor-14.42fd99ec.jpg";